import { useQuery } from "@tanstack/react-query";
import { http } from "../../../../services/HttpService";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../../../consts/api";

export const useUserTimeTrackingGroups = (userId, options = {}) => {
  const res = useQuery(
    [QUERY_KEYS.timeclockSettings.getUserTimeTrackingGroups, userId],
    () =>
      http.get(
        HTTP_ENDPOINTS.timeclockSettings.getUserTimeTrackingGroups(userId),
      ),
    { ...options },
  );

  return { ...res, data: res.data || [] };
};
